
export default class
{
	static pen_color = '#555'

	static canvases = new Map()

	static canvas_modified = new Set()

	static init()
	{
		this.canvases = new Map()
		this.canvas_modified = new Set()

		const data = $('#data')
		const customer = data.data('customer')
		const same = data.data('visit') === Number($('#survey_visit').val())

		$(`#agreement_list > div`).addClass('hidden')
		$(`#survey_list > li`).addClass('hidden')

		$(`#agreement_list > div:not([data-menu_category])`).removeClass('hidden')
		$(`#survey_list > li:not([data-menu_category])`).removeClass('hidden')

		for(const menu_category of data.data('menu_category'))
		{
			$(`#agreement_list > div[data-menu_category~="${menu_category}"]`).removeClass('hidden')
			$(`#survey_list > li[data-menu_category="${menu_category}"]`).removeClass('hidden')
		}

		$('#survey_visit').val(data.data('visit'))

		$('#survey_name').html(`<input class="my-1" type="text" name="name" placeholder="お名前" value="${data.data('name') || ''}"><input class="my-1" type="text" name="ruby" placeholder="フリガナ" value="${data.data('ruby') || ''}">`)
		$('#survey_phone').html(`<input class="my-1" type="text" name="phone" value="${data.data('phone') || ''}">`)

		if(data.data('birthday'))
		{
			const [year, month, day] = data.data('birthday').split('-')

			$('#survey select[name="birth_year"]').val(Number(year)).trigger('change')
			$('#survey select[name="birth_month"]').val(Number(month)).trigger('change')
			$('#survey select[name="birth_day"]').val(Number(day)).trigger('change')
		}
		else if(!same)
		{
			$('#survey select').val('').trigger('change')

			$('#survey_list input[type="checkbox"]').prop('checked', false)
			$('#survey_list input[type="radio"]').prop('checked', false)
		}

		$('#agreement_list canvas[data-agreement]').each((index, element) =>
		{
			const agreement = Number(element.dataset.agreement)
			const canvas = new fabric.Canvas(element.id)

			canvas.isDrawingMode = true
			canvas.freeDrawingBrush.width = 3
			canvas.freeDrawingBrush.color = this.pen_color
			canvas.on('path:created', () => this.canvas_modified.add(agreement))

			this.canvases.set(agreement, canvas)
		})

		$('#agreement_list [data-acceptance][data-agreement]').each((index, element) =>
		{
			const agreement = Number(element.dataset.agreement)
			$(`[name="agreement[${agreement}][accepted]"]`).prop('checked', true)
		})

		if(customer && data.data('response'))
		{
			const response = data.data('response')

			for(const survey_id in response)
			{
				for(const answer of response[survey_id])
				{
					$(`#survey [data-id="${survey_id}-${answer}"]`).prop('checked', true)
				}
			}
		}
	}

	static send_survey(form)
	{
		for(const agreement of this.canvas_modified)
		{
			$(`[data-sign="${agreement}"]`).val(this.canvases.get(agreement).toDataURL())
		}

		return App.common.Network.form_post(form, (success, data) =>
		{
			if(success) App._common.modal_open('return')
		}, false)
	}

	static clear_sign(agreement)
	{
		const canvas = this.canvases.get(agreement)
		canvas.clear()
		canvas.isDrawingMode = true
		canvas.freeDrawingBrush.width = 3
		canvas.freeDrawingBrush.color = this.pen_color

		this.canvas_modified.delete(agreement)
		$(`[data-sign="${agreement}"]`).val('')
		$(`[data-clear="${agreement}"]`).val('1')
	}
}
